import { getRepository, type Repository } from "@prismicio/editor-fields"
import { updateData } from "@prismicio/editor-support/Suspense"

import { env } from "../app/env"
import { baseUrl as coreApiBaseUrl } from "../app/services/core"

export function updateSimulatorURL(
  repository: Repository,
  simulatorUrl: string,
) {
  updateData(
    getRepository,
    [coreApiBaseUrl, env.PRISMIC_PAGE_BUILDER_AUTH_STRATEGY],
    {
      ...repository,
      simulatorUrl,
    },
  )
}

export function autoCompleteSimulatorURL(url: string) {
  if (url.endsWith("/slice-simulator")) return url

  const hasTrailingSlash = url.endsWith("/")

  return `${url}${hasTrailingSlash ? "" : "/"}slice-simulator`
}
